import privateNetwork from '@adm/services/networkRequest';
/**
 * Importação da biblioteca axios para fazer requisições baseadas em Promises.
 */
import axios from 'axios';

/**
 * Classe genérica para requisições em serviços
 */
export default class GenericCrud {
  /**
   * ? Para futuramente atribuir perfis aos endpoints aqui
   * podemos colocar um array com os roles que são autorizados
   * em vez de apenas 'public' e 'private'
   */
  constructor(
    endPoint,
    authorization = {
      get: 'public',
      getOne: 'public',
      post: 'public',
      put: 'public',
      patch: 'public',
      delete: 'public',
    },
    apiVersion = '/v1'
  ) {
    this.endPoint = endPoint.substr(0, 1) === '/' ? endPoint : `/${endPoint}`;
    this.apiVersion =
      apiVersion.substr(0, 1) === '/' ? apiVersion : `/${apiVersion}`;
    this.authorization = {
      get: 'public',
      getOne: 'public',
      post: 'public',
      put: 'public',
      patch: 'public',
      delete: 'public',
      ...authorization,
    };
  }

  /**
   * Método para obtenção de registros
   */
  async get() {
    if (this.authorization['get'] === 'public') {
      return axios(
        `${process.env.REACT_APP_API_HOST}${this.apiVersion}${this.endPoint}`
      );
    } else {
      return privateNetwork(`${this.apiVersion}${this.endPoint}`);
    }
  }

  /**
   * Método para obtenção de um registro em específico
   *
   * @param {*} id
   */
  async getOne(id) {
    if (this.authorization['getOne'] === 'public') {
      return axios(
        `${process.env.REACT_APP_API_HOST}${this.apiVersion}${this.endPoint}/${id}`
      );
    } else {
      return privateNetwork(`${this.apiVersion}${this.endPoint}/${id}`);
    }
  }

  /**
   * Método envio de dados
   *
   * @param {*} body
   */
  async post(body) {
    if (this.authorization['post'] === 'public') {
      return axios.post(
        `${process.env.REACT_APP_API_HOST}${this.apiVersion}${this.endPoint}`,
        body
      );
    } else {
      return privateNetwork.post(`${this.apiVersion}${this.endPoint}`, body);
    }
  }

  /**
   * Método para atualização de um recurso
   *
   * @param {*} body
   */
  async put(body) {
    if (this.authorization['put'] === 'public') {
      return axios.put(
        `${process.env.REACT_APP_API_HOST}${this.apiVersion}${this.endPoint}/${body.id}`,
        body
      );
    } else {
      return privateNetwork.put(
        `${this.apiVersion}${this.endPoint}/${body.id}`,
        body
      );
    }
  }

  /**
   * Método para modificação parcial de um recurso
   *
   * @param {*} body
   */
  async patch(body) {
    if (this.authorization['patch'] === 'public') {
      return axios.patch(
        `${process.env.REACT_APP_API_HOST}${this.apiVersion}${this.endPoint}/${body.id}`,
        body
      );
    } else {
      return privateNetwork.patch(
        `${this.apiVersion}${this.endPoint}/${body.id}`,
        body
      );
    }
  }

  /**
   * Método para remoção de um recurso
   *
   * @param {*} id
   */
  async delete(id) {
    if (this.authorization['delete'] === 'public') {
      return axios.delete(
        `${process.env.REACT_APP_API_HOST}${this.apiVersion}${this.endPoint}/${id}`
      );
    } else {
      return privateNetwork.delete(`${this.apiVersion}${this.endPoint}/${id}`);
    }
  }

  /**
   * Método destinado a transformar ou renomear os atributos de um objeto,
   * básicamente uma tradução para utilizar o atributos em Inglês, que foi
   * a linguagem adotada nesta aplicação, e poder continuar mantendo o padrão
   *
   * @param {Object} data Deve se passar o objeto que deseja transformar
   * @param {Object} mapper Deve se passar um objeto onde as chaves são os
   * atributos da forma como estão sendo usadas na aplicação(em Inglês), e os valores
   * devem ser os atributos da forma que a api está respondendo(em português provavelmete)
   * @param {boolean} fromApi Deve-se passar true quando desejar transformar um objeto
   * que foi recebido da API, e deve-se passar false quando for o inverso, quando precisar
   * enviar algum objeto para a API
   * @returns {Object} Retorna o objeto que foi recebido como parametro, transformado
   */
  prepareData = (data, mapper, fromApi = false) => {
    const preparedData = {};
    if (fromApi) {
      Object.keys(mapper).forEach((k) => (preparedData[k] = data[mapper[k]]));
    } else {
      Object.keys(mapper).forEach((k) => (preparedData[mapper[k]] = data[k]));
    }
    return preparedData;
  };

  /**
   * Retorna o valor apenas de interesse da resposta tipo Apigility
   *
   * @param {object} response A resposta raw do get por exemplo
   * @param {string} key A chave do objeto que deve retornar, caso não tenha retorna sempre o primero item do objeto embedded
   */
  static getEmbeddedData(response, key = null) {
    if (key) {
      return response.data._embedded[key];
    } else {
      const embedded = Object.values(response.data._embedded);
      return embedded[0];
    }
  }

  /**
   * Retorna os dados da requisição
   */
  static getData(response) {
    return response.data;
  }
}
